export enum EVCellBlock {
  Root = 'EVCell',
}
